export default __webpack_public_path__ + "static/296b6fd4-209f-45d6-b8c3-d2cebb7d987c-ba740cea1f289661fe4b3d6772fd0a5c.ttf";